import script from "./Question.vue?vue&type=script&setup=true&lang=ts"
export * from "./Question.vue?vue&type=script&setup=true&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=7d01314a&scoped=true&lang=css"

import exportComponent from "/Users/jgividen/Local Sites/aph-font-testing/app/public/wp-content/plugins/aph-font-app/assets/js/component-lib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d01314a"]])

export default __exports__